import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hiddenInput', 'menu', 'trigger', 'option']

  connect() {
    this.handleClickOutside = this.hide.bind(this)
    document.addEventListener('click', this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle('hidden')
  }

  hide(event) {
    if (this.element.contains(event.target)) return
    this.menuTarget.classList.add('hidden')
  }

  select(event) {
    event.preventDefault()
    const option = event.currentTarget
    const value = option.dataset.value || ''
    this.hiddenInputTarget.value = value
    this.triggerTarget.innerHTML = option.dataset.preview
    this.menuTarget.classList.add('hidden')
    this.hiddenInputTarget.dispatchEvent(
      new Event('change', { bubbles: true })
    )
  }
}
